import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.aalantechsoft.com";

const SEO = ({
  title = "Aalan TechSoft | Software Development & IT Training in Salem",
  description = "Aalan TechSoft provides software development services and practical IT training in Salem, Tamil Nadu, including web, mobile, custom software and full-stack courses.",
  path = "/",
  image = "/Website Icon-Photoroom.png",
  type = "website",
  structuredData,
}) => {
  const canonical = `${SITE_URL}${path}`;
  const imageUrl = image.startsWith("http") ? image : `${SITE_URL}${image}`;
  const defaultStructuredData = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Aalan TechSoft",
      "url": SITE_URL,
      "logo": imageUrl,
      "telephone": "+91-9080108634",
      "email": "Support@aalantechsoft.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "J.H. Towers, 24, LIC Colony Road",
        "addressLocality": "Salem",
        "addressRegion": "Tamil Nadu",
        "postalCode": "636004",
        "addressCountry": "IN"
      },
      "sameAs": [
        "https://www.linkedin.com/company/aalan-tech-soft/",
        "https://www.facebook.com/aalaninfo/"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Aalan TechSoft",
      "url": SITE_URL
    }
  ];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <script type="application/ld+json">
        {JSON.stringify(structuredData || defaultStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
